"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "@/components/auth/Auth";
import PrimaryButtonLink from "@/components/utils/button/PrimaryButtonLink";
export default function GroupHeaderSelect() {
  const $ = _c(10);
  const {
    connectedProfile
  } = useContext(AuthContext);
  let t0;
  if ($[0] !== connectedProfile?.handle) {
    t0 = () => !!connectedProfile?.handle;
    $[0] = connectedProfile?.handle;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const getHaveProfile = t0;
  const [haveProfile, setHaveProfile] = useState(getHaveProfile());
  let t1;
  if ($[2] !== getHaveProfile) {
    t1 = () => setHaveProfile(getHaveProfile());
    $[2] = getHaveProfile;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== connectedProfile) {
    t2 = [connectedProfile];
    $[4] = connectedProfile;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useEffect(t1, t2);
  const noProfileTitle = connectedProfile && !haveProfile ? "Please create a profile" : "Please connect a wallet";
  if (haveProfile) {
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <PrimaryButtonLink href="/network/groups" padding="tw-px-3 tw-py-2 tw-w-full"><svg className="tw-w-5 tw-h-5" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg><span>Create A Group</span></PrimaryButtonLink>;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <svg className="tw-flex-shrink-0 tw-self-center tw-w-5 tw-h-5 tw-text-primary-300" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== noProfileTitle) {
    t4 = <div className="tw-w-full tw-inline-flex tw-items-center tw-rounded-lg tw-bg-primary-400/5 tw-border tw-border-solid tw-border-primary-400/30 tw-px-4 tw-py-3"><div className="tw-flex tw-items-center">{t3}<div className="tw-ml-3 tw-self-center"><p className="tw-text-sm tw-mb-0 tw-font-semibold tw-text-primary-300">{noProfileTitle}</p></div></div></div>;
    $[8] = noProfileTitle;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}